import React, { Component } from 'react'
import { Dialog, DialogTitle, DialogActions, Card, CardContent, TextField, Button } from '@material-ui/core'
import { connect } from 'react-redux'
import CloseIcon from '@material-ui/icons/Close';
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles';
import { openSnackBar } from '../../actions/snack-bar';
import { changePassword } from '../../actions/authentication'

class ChangePasswordModal extends Component {

  state = {
    current_password: '',
    new_password: '',
    confirm_new_password: ''
  }

  closeModal = () => {
    this.props.dispatch({ type: 'CHANGE_PASSWORD', payload: false });
    this.setState({ current_password: '', new_password: '', confirm_new_password: '' });
  }

  updatePassword = (e) => {
    e.preventDefault();
    const { current_password, new_password, confirm_new_password } = this.state;
    if (!current_password.length) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter the current password'
        })
      )
      return
    } else if (!new_password.length) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter the new password'
        })
      )
      return
    } else if (!confirm_new_password.length) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter a confirm password'
        })
      )
      return
    } else if (new_password !== confirm_new_password) {
      this.props.dispatch(
        openSnackBar({
          message: 'New password and confirm password must match'
        })
      )
      return
    }

    this.props
      .dispatch(changePassword(this.props.authentication.authenticatedUser.id, { current_password: current_password, new_password: new_password }))
      .then(response => {
        this.closeModal();
      })
      .catch(err => {
        //this.closeModal();
      })
  }
  render() {
    const { classes } = this.props;
    return (
      <Dialog onClose={this.closeModal} open={this.props.open} >
        <DialogTitle className={classes.dialogTitle} onClose={this.closeModal}>
          Change Password
          <CloseIcon onClick={this.closeModal} />
        </DialogTitle>
        <Card className={classes.dialogContainer}>
          <form
            onSubmit={this.updatePassword}
          >
            <CardContent className={classes.dialogInputContainer}>
              <TextField
                label="Current Password"
                onChange={e => this.setState({ current_password: e.target.value })}
                value={this.state.current_password}
                type="password"
                fullWidth
                className={classes.dialogInput}
              />
              <TextField
                label="Enter New Password"
                onChange={e => this.setState({ new_password: e.target.value })}
                value={this.state.new_password}
                type="password"
                fullWidth
                className={classes.dialogInput}
              />
              <TextField
                label="Confirm New Password"
                onChange={e => this.setState({ confirm_new_password: e.target.value })}
                value={this.state.confirm_new_password}
                type="password"
                fullWidth
                className={classes.dialogInput}
              />
            </CardContent>
            <DialogActions className={classes.dialogButtonContainer}>
              <Button fullWidth className={classes.dialogSubmitButton} color="primary" variant="contained" type="submit">
                Update Password
              </Button>
            </DialogActions>
          </form>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    open: state.changePasswordModal
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(ChangePasswordModal)
